import React from 'react';
import { Container } from 'react-bootstrap';
import {
  FiArrowUpRight,
  FiBell,
  FiCalendar,
  FiCheck,
  FiCreditCard,
  FiGlobe,
  FiUsers,
  FiZap,
} from 'react-icons/fi';
import '../css/Planes.css';

const REGISTRO_DEMO_URL = 'https://clientes.imagy.ar/dashboard/demo';

const funcionalidades = [
  {
    icon: FiGlobe,
    title: 'Página de reservas propia',
    text: 'Un link listo para compartir y recibir turnos las 24 horas.',
  },
  {
    icon: FiCalendar,
    title: 'Agenda inteligente',
    text: 'Disponibilidad calculada según cada servicio, duración y profesional.',
  },
  {
    icon: FiBell,
    title: 'Notificaciones por email',
    text: 'Avisos automáticos por email para tu negocio y tus clientes, sin costo.',
  },
  {
    icon: FiUsers,
    title: 'Todo tu equipo',
    text: 'Organizá profesionales, servicios y horarios desde un mismo lugar.',
  },
  {
    icon: FiCreditCard,
    title: 'Señas y medios de pago',
    text: 'Pedí comprobantes y confirmá reservas con mayor seguridad.',
  },
  {
    icon: FiZap,
    title: 'Acompañamiento real',
    text: 'Te ayudamos a dejar tu cuenta lista y aprovecharla desde el inicio.',
  },
];

function Planes() {
  return (
    <section id="planes" className="imagy-pricing">
      <div className="imagy-pricing__glow imagy-pricing__glow--one" />
      <div className="imagy-pricing__glow imagy-pricing__glow--two" />

      <Container className="imagy-pricing__container">
        <header className="imagy-pricing__heading">
          <span className="imagy-pricing__eyebrow">
            <FiZap aria-hidden="true" /> Plan simple, sin vueltas
          </span>
          <h2>
            Probá Imagy gratis. <span>Después, elegí Premium.</span>
          </h2>
          <p>
            Creá tu página, organizá la agenda y enviá notificaciones por email gratis.
            El primer mes es gratis y sin WhatsApp. Después podés continuar con Premium y sumar recordatorios automáticos.
          </p>
        </header>

        <div className="imagy-pricing__card">
          <div className="imagy-pricing__details">
            <div className="imagy-pricing__plan-title">
              <div>
                <span>Versión de prueba · 1 mes</span>
                <h3>Imagy Prueba</h3>
              </div>
              <span className="imagy-pricing__active">
                <i /> Sin WhatsApp
              </span>
            </div>

            <p className="imagy-pricing__intro">
              Todo lo necesario para empezar a recibir reservas y ordenar tus turnos,
              sin tarjeta durante 1 mes.
            </p>

            <div className="imagy-pricing__features">
              {funcionalidades.map(({ icon: Icon, title, text }) => (
                <article key={title} className="imagy-pricing__feature">
                  <span className="imagy-pricing__feature-icon">
                    <Icon aria-hidden="true" />
                  </span>
                  <div>
                    <h4>{title}</h4>
                    <p>{text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside className="imagy-pricing__checkout">
            <span className="imagy-pricing__trial">Imagy Premium</span>

            <div className="imagy-pricing__price-label">Recordatorios por WhatsApp</div>
            <div className="imagy-pricing__price">
              <sup>$</sup>
              <strong>15.000</strong>
              <span>ARS<br />por mes</span>
            </div>

            <p className="imagy-pricing__price-note">
              Para nuevas cuentas, Premium comienza después del mes de prueba e incluye
              la agenda, la página de reservas, los emails y los recordatorios por WhatsApp.
            </p>

            <a className="imagy-pricing__cta" href={REGISTRO_DEMO_URL}>
              Crear mi cuenta gratis
              <FiArrowUpRight aria-hidden="true" />
            </a>

            <div className="imagy-pricing__reassurance">
              <span><FiCheck aria-hidden="true" /> Sin tarjeta de crédito</span>
              <span><FiCheck aria-hidden="true" /> Configuración acompañada</span>
              <span><FiCheck aria-hidden="true" /> Cancelás cuando quieras</span>
            </div>
          </aside>
        </div>

        <div className="imagy-pricing__footer">
          <span><strong>$0 por 1 mes</strong> agenda y página de reservas</span>
          <span><strong>Incluido en la prueba</strong> notificaciones por email</span>
          <span><strong>$15.000 por mes</strong> Premium para nuevas cuentas después del primer mes</span>
        </div>
      </Container>
    </section>
  );
}

export default Planes;
